module.exports = __webpack_public_path__ + "assets/img/8d1f8eb72a407c16e4766fc5553ad689.png";